<template>
  <v-list density="compact" nav class="px-1">
    <template v-for="app in clientAppsList" :key="app.id">
      <v-list-item
        v-tooltip:end="app.name"
        :active="isActive(app)"
        :value="app.name"
        class="d-flex justify-center"
        :to="Object.assign({}, getAppLocation(app))"
        @click="selectClientApp(app)"
      >
        <v-icon :icon="getAppIcon(app)" />
      </v-list-item>
      <v-list-item-subtitle
        class="text-center"
        :style="{
          fontSize: '0.67rem',
        }"
      >
        {{ truncatedAppName(app.name) }}
      </v-list-item-subtitle>
    </template>
  </v-list>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import {
  clientAppIsKnown,
  clientAppRegistryGet,
} from '@/apps/clientAppRegistry'
import { clientAppDefaultRouteName } from '@/apps/clientAppRegistry'
import { getLocationPreservingState } from '@/apps/routingUtils'
import { useNavigationVisibilityStore } from '@/store/NavigationVisibilityStore'

const store = useStore()
const route = useRoute()
const router = useRouter()

const navigationVisibilityStore = useNavigationVisibilityStore()
const clientApps = computed(() =>
  store.getters['global/collection']('client-app')
)

const isAppKnown = (app) => clientAppIsKnown(app.view_id)

const clientAppsList = computed(() => {
  if (clientApps.value && clientApps.value.objects) {
    return clientApps.value.objects.filter((app) => isAppKnown(app))
  }
  return []
})

const truncatedAppName = (name) => {
  if (name.length < 11) {
    return name
  } else {
    return `${name.slice(0, 9)}...`
  }
}

const isActive = (app) => route.params.app_handle === app.handle

const selectClientApp = (app) => {
  if (isActive(app)) {
    // toggle effect when clicking on the current app
    navigationVisibilityStore.appMenuVisibility
      ? navigationVisibilityStore.setAppMenuNotVisible()
      : navigationVisibilityStore.setAppMenuVisible()
  } else navigationVisibilityStore.setAppMenuVisible()
}

const getAppLocation = (app) => {
  if (isActive(app)) {
    return {
      name: route.name,
      params: {
        app_handle: app.handle,
      },
    }
  } else {
    return getLocationPreservingState(
      clientAppDefaultRouteName(app.view_id),
      router,
      app.handle
    )
  }
}

const getAppIcon = (app) => {
  const icon = clientAppRegistryGet(app.view_id, 'icon')
  if (icon.startsWith('fa-')) {
    return `fa ${icon}`
  }
  return `mdi ${icon} mdi-24px`
}
</script>

<style lang="scss" scoped>
i.fa {
  min-height: 32px;
  margin-top: 5px;
}
</style>
